import {useState} from 'react'
import {useForm} from 'react-hook-form'
import storage from 'services/storage'

const useAuth = (useAuthMutation, token) => {
    const [
        doAuth, // This is the mutation trigger
        {isLoading, error: authError, data: authResponse}, // This is the destructured mutation result
    ] = useAuthMutation()

    const [errorMessage, setErrorMessage] = useState(null)

    const {
        getValues: getFormValues,
        setValue: setFormValue,
        handleSubmit,
        control: formControl,
        formState: {errors: formErrors},
    } = useForm()

    const onSubmit = (submittedData) => {
        const {password, confirmPassword, rememberMe} = submittedData
        if (confirmPassword && password && password !== confirmPassword) {
            setErrorMessage('Passwords do not match')
            return
        }
        storage.setRememberMe(rememberMe || false)
        const values = token ? {...submittedData, token} : submittedData
        doAuth(values)
    }

    const submit = handleSubmit(onSubmit)

    return {
        formControl,
        submit,
        isLoading,
        authError,
        errorMessage,
        formErrors,
        getFormValues,
        setFormValue,
        authResponse,
    }
}

export default useAuth
